/*
 * auth reducer
 */
import {
    LOGIN_LOAD_REQUESTED,
    LOGIN_LOAD_SUCCEEDED,
    RENEW_ID_TOKEN_SUCCEEDED,
    RESET_STATE
} from './constants';

const initialState = false;

function authReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN_LOAD_REQUESTED:
            return false;
        case LOGIN_LOAD_SUCCEEDED:
            return action.payload;
        case RENEW_ID_TOKEN_SUCCEEDED:
            return action.payload;
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}

export default authReducer;
